import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class MustRender extends PureComponent {
    render() {
        const { isTrueThat, children } = this.props
        return isTrueThat ? children : null
    }
}

MustRender.propTypes = {
    isTrueThat: PropTypes.bool,
    children: PropTypes.oneOfType([
        'node', 
        'string'
    ]),
}
